import React from 'react';

import LinkBox from './link-box';

export default function EpisodeNav({ prev, next }) {
  return (
    <div className="flex justify-between gap-2">
      {prev && (
        <LinkBox href={`/episodes/${prev.node.fields.slug}`}>
          ← {prev.node.id} - {prev.node.guest}
        </LinkBox>
      )}
      {next && (
        <LinkBox href={`/episodes/${next.node.fields.slug}`}>
          {next.node.id} - {next.node.guest} →
        </LinkBox>
      )}
    </div>
  );
}
